export default function SVG1_3(props: any) {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.0987 0.25293H0.535156V23.351H4.0987V14.0084L10.9334 19.5425C11.2388 19.7899 11.6995 19.8636 12.1013 19.7291C12.5031 19.5945 12.7602 19.2777 12.7602 18.9261V15.5796C13.9655 15.3669 16.4406 15.0978 18.4334 15.9833C19.8316 16.6039 20.7906 17.7151 21.2834 19.2864C21.3959 19.6379 21.7656 19.8984 22.2102 19.9374C22.2477 19.9418 22.2852 19.9418 22.3227 19.9418H22.3227C22.7245 19.9418 23.0995 19.7551 23.2817 19.46L23.2818 19.4598C23.3637 19.3226 25.2629 16.1425 23.2335 13.1402C21.6317 10.7747 18.1227 9.27287 12.787 8.67388V5.45324C12.787 5.10167 12.5245 4.78481 12.1281 4.65026C11.7263 4.5157 11.2655 4.58949 10.9602 4.8369L4.0987 10.3998V0.25293Z"
                fill="#23F2FF"
            />
        </svg>
    );
}
